import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// Components
import AppLink from 'components/AppLink';

// Styles
import styles from './styles.styl';

const Social = ({ className, socials }) => (
  <div className={cn(className, styles.Social)}>
    <div className={styles.Social__list}>
      {socials.map((social, index) => (
        <AppLink key={index} href={social.url} className={styles.Social__link} targetBlank>
          <img className={styles.Social__icon} src={social.image} alt={social.title} />
        </AppLink>
      ))}
    </div>
  </div>
);

Social.defaultProps = {
  className: '',
};

Social.propTypes = {
  className: PropTypes.string,
  socials: PropTypes.array,
};

export default Social;
